'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('riskModule')

.factory('commonRiskSelfAssessmentService', ['$http', '$q', function ($http, $q) {

    var service = {};
    var baseUrl = environment.apiUrl + '/Pilot/api/RiskSelfAssessment';
    var returnData = function (response) {
        return response.data;
    };

    service.statusAssessorsList = function () {
        return $http
            .get(baseUrl)
            .then(function (response) { return response.data; });
    };

    service.isAssessor = function (authenticatedAssessorID) {
        var url = baseUrl + '/Assessment/IsAssessor';

        if (authenticatedAssessorID != null) {
            url = baseUrl + '/Assessor@' + authenticatedAssessorID + '/Assessment/IsAssessor';
        }
        return $http
            .get(url)
            .then(returnData);
    };

    service.getAllCriterias = function () {
        return $http
            .get(baseUrl + '/Criteria', {cache: true})
            .then(returnData);
    };

    service.getAllCriteriasByTypeAndByCode = function () {
        return service
              .getAllCriterias()
              .then(function (criterias) {
                  var byTypeAndCode = _.chain(criterias)
                                       .groupBy('RiskLookupAssessmentTypeName')
                                       .mapValues(function (criteriasByType) {
                                           var criteriasByCode = _.chain(criteriasByType)
                                                                  .groupBy('Code')
                                                                  .mapValues(function (byCode) {
                                                                      return byCode[0];
                                                                  })
                                                                  .value();

                                           return criteriasByCode;
                                       })
                                       .value();

                  return byTypeAndCode;
              });
    };

    service.getNACriteria = function () {
        return { Color: 'default', Name: 'N/A' };
    };

    service.computeOwnerOverallCriteria = function (severityCode, probabilityCode, mitigationCode) {
        return $http
                .post(baseUrl + '/Criteria/Overall/Owner/Compute', {
                    severityCode: severityCode,
                    probabilityCode: probabilityCode,
                    mitigationCode: mitigationCode
                })
                .then(returnData);
    };

    service.getAssessmentQuestions = function (assessorId) {
        var url = baseUrl + '/Assessment/Questions';

        if (assessorId != null) {
            url = baseUrl + '/Assessor@' + assessorId + '/Questions';
        }
        return $http
            .get(url)
            .then(returnData);
    };

    service.updateAssessmentQuestions = function (assessmentQuestionsContainer, assessorId) {
        var url = baseUrl + '/Assessment/Questions';

        if (assessorId != null) {
            url = baseUrl + '/Assessor@' + assessorId + '/Questions';
        }
        return $http
            .post(url, assessmentQuestionsContainer)
            .then(returnData);
    };

    service.createRiskAssessmentAnswer = function (riskAssessmentQuestionId, riskAssessmentQuestion) {
        return {
            RiskAssessmentQuestionID: riskAssessmentQuestionId,
            AssessorValue: null,
            Depth: riskAssessmentQuestion.RiskAssessmentAnswers.length + 1
        }
    };

    return service;
}]);
